import { createAsyncThunk } from '@reduxjs/toolkit';
import { authApi } from '../../../api/auth/authApi.js';

export const login = createAsyncThunk('auth/login', async ({ credentials, t }, thunkAPI) => {
    try {
        const response = await authApi.login(credentials, t);
        return response.data;
    } catch (e) {
        return thunkAPI.rejectWithValue(e);
    }
});